import { Avatar } from "@radix-ui/themes";
import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import { useFetchLicense } from "../../../hooks/useFetchLicense";
import { useAppStore } from "../../../stores/RootStore";
import { Site, Upload } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../../ui/SelectButton/SelectButton";

const LicenseAuthSetter = () => {
  const currentSite = useAppStore((store) => store.currentSite);
  const setCurrentSite = useAppStore((store) => store.setCurrentSite);
  const setLicenseCheck = useAppStore(store => store.setLicenseCheck)

  const [errors, setErrors] = useState<Array<any>>([]);
  const [invalidLicense, setInvalidLicense] = useState(false);
  const { register, reset, handleSubmit, control, getValues } = useForm({
    defaultValues: {
      license: currentSite?.license_key,
    },
  });

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/users/sites/${currentSite?.id}`,
    true
  );

  // Проверка существования ключа организации
  const [{ response: licenseResponse, error: licenseError, statusCode }, doFetchLicenseCheck] =
    useFetchLicense(`/licenses/check`);

  // Успешная проверка лицензии
  useEffect(() => {
    if (!licenseResponse) return;
    doFetchItemSave({
      method: "PUT",
      data: {
        data: {
          license_key: getValues("license"),
        },
      },
    });
  }, [licenseResponse]);

  // Провальная проверка лицензии
  useEffect(() => {
    if (!licenseError) return;
    if (statusCode == "404") {
      setInvalidLicense(true);
      console.log("Отсутствует такой ключ организации");
      reset({ license: currentSite?.license_key });
    }
    if (statusCode == "403") {
      console.log("Срок лицензии истёк или превышено количество активированных копий");
    }
  }, [licenseError]);

  const onSubmit = (formData: any) => {
    setErrors([]);
    setInvalidLicense(false);
    // Проверка ключа организации на корректность при изменении ключа

    doFetchLicenseCheck({
      method: "POST",
      data: {
        key: formData.license,
        workplace_key: "test1", // В web версии нельзя получить machine key
      },
    });
  }

  const addSite = (itemSaveResponse: { data: { attributes: any } }) => {
    const newSiteData = { ...currentSite, ...itemSaveResponse.data.attributes } as unknown as Site;
    setCurrentSite(newSiteData);
  };

  const navigate = useNavigate()

  useEffect(() => {
    if (!saveResponse) return;
    addSite(saveResponse);
    setLicenseCheck(true);
    navigate('/')
  }, [saveResponse]);

  useEffect(() => {
    if (!saveError) return;
    setErrors(saveError.errors);
  }, [saveError]);

  return (
    <ScrollArea className="w-full bg-background">
      <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden my-[4rem]">
        <div className="text-xl font-semibold">{t("company_settings")}</div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col w-full pt-8 h-full gap-3">
            {invalidLicense && (
              <li className="text-red-700 w-full">{t("error")}: введённый ключ организации неверен</li>
            )}
            <Controller
              name="license"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("license")}*`} />
                </div>
              )}
            />
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default LicenseAuthSetter;
